"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionClose = exports.AIContentCategory = void 0;
var AIContentCategory;
(function (AIContentCategory) {
    AIContentCategory["OpenAIContent"] = "OpenAIContent";
    AIContentCategory["CloseAIContent"] = "CloseAIContent";
    AIContentCategory["GenerateAIContent"] = "GenerateAIContent";
    AIContentCategory["AddAIContent"] = "AddAIContent";
    AIContentCategory["DiscardAIContent"] = "DiscardAIContent";
})(AIContentCategory || (exports.AIContentCategory = AIContentCategory = {}));
var ActionClose;
(function (ActionClose) {
    ActionClose["CloseByInsertingTheSubject"] = "CloseByInsertingTheSubject";
    ActionClose["CloseByWatingHotmartAI"] = "CloseByWatingHotmartAI";
    ActionClose["CloseBySelectionItems"] = "CloseBySelectionItems";
})(ActionClose || (exports.ActionClose = ActionClose = {}));
